__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.8.2-3884165-14448/_next/";